import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['progress', 'scroller', 'content', 'item', 'previous', 'next', 'dots', 'dot']

  // ==== Life Cycle ==== //
  initialize () {
    this.progressCallback = this.progress.bind(this)
    this.ticking = false
    if (this.indexable) this.paginate()
  }

  connect () {
    this.contentTarget.addEventListener('scroll', this.progressCallback)
    this.togglePrevious()
    this.toggleNext()
  }

  disconnect () {
    this.contentTarget.removeEventListener('scroll', this.progressCallback)
  }

  // ==== Actions ==== //
  previous () {
    this.contentTarget.scrollLeft -= this.itemTargets[0].offsetWidth

    if (!this.indexable) return
    this.toggleDot()
  }

  next () {
    this.contentTarget.scrollLeft += this.itemTargets[0].offsetWidth

    if (!this.indexable) return
    this.toggleDot()
  }

  // ==== Logic ==== //
  progress () {
    if (this.hasProgressTarget) {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          const x = (this.progressTarget.offsetWidth - this.scrollerTarget.offsetWidth) * this.scrollPercentage
          this.scrollerTarget.style.transform = `translateX(${x}px)`
          this.ticking = false
        })
        this.ticking = true
      }
    }
    this.index = Math.max(0, Math.ceil(this.scrollPercentage * this.dotTargets.length) - 1)
    this.toggleDot()
    this.togglePrevious()
    this.toggleNext()
  }

  togglePrevious () {
    if (!this.hasPreviousTarget) return
    this.toggleNavigation(this.previousTarget, !this.scrollable && this.index > 0)
  }

  toggleNext () {
    if (!this.hasNextTarget) return
    this.toggleNavigation(this.nextTarget, !this.scrollable && this.index < this.itemTargets.length - 1)
  }

  toggleDot () {
    this.dotTargets.forEach((dot, index) => {
      dot.classList.toggle('slider__dot--active', index === this.index)
    })
  }

  toggleNavigation (element, force) {
    element.style.display = force ? 'block' : 'none'
  }

  paginate () {
    if (!this.hasDotsTarget || this.itemTargets.length < 2) return
    this.dotsTarget.innerHTML = ''

    this.itemTargets.forEach((item, index) => {
      const dot = document.createElement('span')

      dot.className = 'slider__dot'
      dot.setAttribute('data-slider-target', 'dot')
      dot.setAttribute('data-slider-dot-index', index)
      item.setAttribute('data-slider-item-index', index)

      this.dotsTarget.appendChild(dot)
    })

    this.toggleDot()
  }

  // ==== Getters and Setters ==== //

  get indexable () {
    return Boolean(this.data.get('indexable'))
  }

  get index () {
    return Number(this.data.get('index'))
  }

  set index (value) {
    return this.data.set('index', value)
  }

  get scrollable () {
    return this.data.get('scrollable') === 'true' && this.contentTarget.offsetWidth < this.contentTarget.scrollWidth
  }

  get scrollPercentage () {
    return this.contentTarget.scrollLeft / (this.contentTarget.scrollWidth - this.contentTarget.offsetWidth)
  }
}
